const REQUIRED_EVENT_TEXT_FIELDS = Object.freeze([
    "event_details",
    "event_recommend",
    "event_summary",
    "event_notes",
]);

export const REQUIRED_EVENT_TEXT_MAX_LENGTH = 2000;

export const normalizeText = (value) => {
    if (value == null) {
        return "";
    }

    return String(value).trim();
};

export const isBlank = (value) => {
    return normalizeText(value).length === 0;
};

export const normalizeRequiredEventTextFields = (values = {}) => {
    const normalized = {};

    REQUIRED_EVENT_TEXT_FIELDS.forEach((field) => {
        normalized[field] = normalizeText(values[field]);
    });

    return normalized;
};

export const hasValidRequiredEventTexts = (values = {}) => {
    const normalized = normalizeRequiredEventTextFields(values);

    return REQUIRED_EVENT_TEXT_FIELDS.every((field) => {
        const value = normalized[field];
        return value.length > 0 && value.length <= REQUIRED_EVENT_TEXT_MAX_LENGTH;
    });
};
